import { ZyTrack } from './core'

export default new ZyTrack()